import React, { Component } from "react";
import { withRouter } from "react-router";
import { withStyles } from "material-ui/styles";
import Sidebar from "./sidebar/Sidebar";
import MainContainer from "../controls/MainContainer";
import Routes from "./Routes";

const styles = theme => ({
  root: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr)",
    width: "100%",
    height: "100vh",
    overflow: "hidden"
  },

  rootDesktop: {
    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "200px minmax(0, 1fr)"
    }
  },

  rootSale: {
    gridTemplateColumns: "minmax(0, 1fr)"
  },

  content: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    minHeight: 0,
    width: "100%",
    height: "100vh",
    overflow: "hidden"
  }
});

class Home extends Component {
  state = {
    mobileOpen: false
  };

  handleDrawerToggle = () => {
    this.setState({
      mobileOpen: !this.state.mobileOpen
    });
  };

  render() {
    const { classes } = this.props;
    const { mobileOpen } = this.state;

    const isSale =
      this.props.history.location.pathname === "/sale";

    const rootClass = isSale
      ? `${classes.root} ${classes.rootSale}`
      : `${classes.root} ${classes.rootDesktop}`;

    return (
      <div className={rootClass}>
        <Sidebar
          mobileOpen={mobileOpen}
          handleDrawerToggle={this.handleDrawerToggle}
        />

        <div className={classes.content}>

          <MainContainer>
            <Routes />
          </MainContainer>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(Home));


